<template>
  <div id="view">
      <div class="title">
          <van-icon name="play" />主页面效果预览
      </div>
      <div class="box">
          <iframe height="100%" width="100%" :src="message"></iframe>
      </div>
      <div class="footer">
          <div class="card" @click="skiplink">
              <div>
                  <van-icon name="down" />
              </div>
              生成链接
          </div>
      </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
        message: '',
    };
  },
  methods: {
      skiplink(){
          this.$router.push({path:'/link'})
      },
      skipFn(){
          this.$router.push({path:'/info'})
      },
      getLink(){
        let that = this;
        let params = {};
        let b = this.$route.query.b;
        let c = this.$route.query.c;
        this.$post('api/divination/user/createInvocationUrl', params)
        .then((res) => {

            console.log(this.$route.query.name)
            if(this.$route.query.name == 'one'){
              this.message = (res.data);
            }else{
              this.message = (res.data + '&person=true');
            }
            //this.message = (res.data + '&b=' + b + '&c=' + c);
        }) 
      },
  },
  created(){
    this.getLink();
  }
};
</script>
<style scope>
#view .footer{
    margin-top: 25px;
    padding-bottom: 30px;
}
#view .footer .link{
    color: rgba(96, 25, 133);
    font-size: 10px;
}
#view .footer .card{
    background-color: rgba(96, 25, 133);
    border-radius: 25px;
    height: 30px;
    line-height: 30px;
    width: 180px;
    font-size: 16px;
    color:#fff;
    margin: 10px auto;
    position: relative;
    text-align:center;
}
#view .footer .card > div{
    display: inline-block;
    position: absolute;
    left:0;
    width: 26px;
    height: 26px;
    left:2px;
    top:2px;
    border-radius: 100%;
    background: #fff;
    color: rgba(96, 25, 133);
    transform: rotate(270deg);
}
#view .btn{
  display:inline-block;
  width: 80px;
  vertical-align: middle;
  background-color: rgba(96,25,133);
  color:#fff;
  text-align:center;
  border-radius: 18px;
  margin-left: 20px;
  font-size: 15px;
}
#view .title{
  font-size: 16px;
  text-align: left;
  padding: 20px 0 0 20px;
}
#view .title .van-icon-play{
  color: rgba(96, 25, 133);
}
#view .box{
    pointer-events: none;
  width: 358px;
  height: 600px;
  border: 1px solid #eee;
  margin: 0 auto;
  background:#fff;
  margin-top: 10px;
  padding:0;
}
</style>

